'use strict';

// core version + modules:
import Swiper, { Navigation, Scrollbar, A11y } from 'swiper';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';

const SliderMulti = {
    els: null,
    init: function () {
        SliderMulti.els = document.querySelectorAll('.f-slider.multi--');
        if (SliderMulti.els && SliderMulti.els.length > 0) {
            SliderMulti.els.forEach(el => {
                SliderMulti.create(el);
            });
        }
    },
    create: function (el) {
        const slider = el.querySelector('.swiper');
        const showArrows = slider.dataset.showArrows !== "0";
        const prevArrow = slider.querySelector(".f-slider__navigation-prev");
        const nextArrow = slider.querySelector(".f-slider__navigation-next");

        slider.swiper = null;


        let modules = "";
        let navigation = null;
        let scrollbar = null;

        const setArrowVisibility = (isVisible) => {
            const visibility = isVisible ? "visible" : "hidden";
            if (prevArrow) {
                prevArrow.style.visibility = visibility;
                prevArrow.tabIndex = isVisible ? 0 : -1;
                prevArrow.setAttribute("aria-hidden", isVisible ? "false" : "true");
            }
            if (nextArrow) {
                nextArrow.style.visibility = visibility;
                nextArrow.tabIndex = isVisible ? 0 : -1;
                nextArrow.setAttribute("aria-hidden", isVisible ? "false" : "true");
            }
        };

        const syncArrowVisibility = (swiper) => {
            if (!showArrows) {
                setArrowVisibility(false);
                return;
            }

            if (!swiper || !swiper.navigation || !swiper.navigation.nextEl || !swiper.navigation.prevEl) {
                setArrowVisibility(true);
                return;
            }

            const bothDisabled = swiper.navigation.nextEl.classList.contains("swiper-button-disabled")
                && swiper.navigation.prevEl.classList.contains("swiper-button-disabled");

            setArrowVisibility(!bothDisabled);
        };
        const refreshSwiperState = (swiper) => {
            if (!swiper) {
                return;
            }

            swiper.update();
            if (swiper.navigation && swiper.navigation.update) {
                swiper.navigation.update();
            }
            syncArrowVisibility(swiper);
        };

        if (slider.dataset.navigation === "arrows") {
            const config = {
                modules: [A11y],
                a11y: true,
                spaceBetween: 16,
                slidesPerView: "auto",
                loop: false,
                speed: 600,
                autoHeight: false,
                breakpoints: {
                    841: {
                        spaceBetween: 24,
                    },
                    1320: {
                        spaceBetween: 32,
                    }
                },
            };

            if (showArrows) {
                config.modules = [Navigation, A11y];
                config.navigation = {
                    prevEl: ".f-slider__navigation-prev",
                    nextEl: ".f-slider__navigation-next",
                };
                config.on = {
                    init: function () {
                        if(slider.swiper.slides.length <= 3){
                            slider.classList.add("threeorless");
                            console.log(slider);
                        } else {
                            slider.classList.remove("threeorless")
                            console.log(slider);
                        }
                        syncArrowVisibility(this);
                        requestAnimationFrame(() => refreshSwiperState(this));
                        requestAnimationFrame(() => requestAnimationFrame(() => refreshSwiperState(this)));
                        setTimeout(() => refreshSwiperState(this), 200);
                    },
                    resize: function () {
                        refreshSwiperState(this);
                    },
                    slideChange: function () {
                        syncArrowVisibility(this);
                    },
                    update: function () {
                        syncArrowVisibility(this);
                    },
                    breakpoint: function () {
                        syncArrowVisibility(this);
                    },
                };
            } else {
                config.on = {
                    init: function () {
                        syncArrowVisibility(this);
                    },
                };
            }

            slider.swiper = new Swiper(slider, config);
            syncArrowVisibility(slider.swiper);
            window.addEventListener("load", () => refreshSwiperState(slider.swiper), { once: true });
        }
        if (slider.dataset.navigation === "scrollbar") {
            slider.swiper = new Swiper(slider, {
                modules: [Scrollbar, Avisible1y],
                a11y: true,
                spaceBetween: 16,
                slidesPerView: "auto",
                loop: false,
                speed: 600,
                autoHeight: false,
                scrollbar: {
                    el: ".f-slider__scrollbar",
                    hide: false,
                    draggable: true
                }
            });
        }

    },
};

export default SliderMulti;
